<template>
    <TsSection>
        <TsTypography as="h2" :align="isMobile ? 'center' : 'left'">{{ title }}</TsTypography>
        <TsGrid :cols="3">
            <TsColumn v-for="el in data" :key="el.key">
                <TsCard no-shadow append-class="p-0">
                    <template #header>
                        <TsHeroBanner class="rounded-b-none " root-class="mb-0" :background-image="el.image" />
                    </template>
                    <template #content>
                        <TsRow class="items-center justify-between mx-4 h-full">
                            <TsColumn class="is-7 p-0">
                                <TsTypography append-class="mb-3">{{ el.desc }}</TsTypography>
                            </TsColumn>
                            <TsColumn class="is-4  text-right p-0">
                                <TsButton label="Explore" />
                            </TsColumn>
                        </TsRow>
                    </template>
                </TsCard>
            </TsColumn>
        </TsGrid>
        <TsRow class="justify-center my-4">
            <TsButton :label="buttonLabel" />
        </TsRow>
    </TsSection>
</template>

<script setup lang="ts">
const { isMobile } = useDevice();

const TsGrid = defineAsyncComponent(
    () => import('~/components/organisms/TsGrid.vue')
);

const TsHeroBanner = defineAsyncComponent(
    () => import('~/components/organisms/TsHeroBanner.vue')
);

type Data = {
    key: number;
    desc: string;
    image: string;
}

type Props = {
    title: string;
    data?: Data[];
    buttonLabel: string;
}

const props = withDefaults(defineProps<Props>(), {
    title: 'Our 25th Catalogue contains:',
    buttonLabel: 'Show more',
    data: () => [
        {
            key: 1,
            desc: 'Our top launched screwdrivers. with amazing offers . The most...',
            image: '/images/catalogueImage1.webp'
        }, {
            key: 2,
            desc: 'Amazing service offline as well as online. creating relationship with...',
            image: '/images/catalogueImage2.webp'
        },
        {
            key: 3,
            desc: 'Now Build your own workshop, with our best tools...',
            image: '/images/catalogueImage3.webp'
        },
        {
            key: 4,
            desc: 'Amazing service offline as well as online. creating relationship with...',
            image: '/images/catalogueImage4.webp'
        },
        {
            key: 5,
            desc: 'Now Build your own workshop, with our best tools...',
            image: '/images/catalogueImage5.webp'
        },
        {
            key: 6,
            desc: 'Now get heavy duty tools with 1 year warranty and easy shipping service.',
            image: '/images/catalogueImage6.png'
        }]
});
</script>